import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eQuyCheActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as any[], // Replace with the actual type if known
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as any | undefined, // Replace with the actual type if known
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as any, // Replace with the actual type if known
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",
}

export const eQuyCheActionIds = generateActionTypeIds(eQuyCheActionsObj, "QUY_CHE");
export type IQuyCheActionTypes = IGenericActionType<typeof eQuyCheActionsObj, "QUY_CHE">;